import React from 'react';
import { Typography } from '@material-ui/core';
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import moment from "moment";
import {useConfig} from "../../context/configContext";
import theme from "./styles";
import translate from "../../misc/applyTranslation";

const OpenRuns = ({openRunsExpanded, data = []}) => {
  const config = useConfig();
  const classes = theme(config);

  return (
    <>
      {openRunsExpanded && (
        <div className={classes.openRunsPanel}>
          {data.length === 0 ? (
            <div className={classes.openRunsEmpty}>
              <Typography className={classes.openRunsEmptyTitle}>
                {translate("n8n", "open_runs_empty_title")}
              </Typography>
              <Typography className={classes.openRunsEmptyText}>
                {translate("n8n", "open_runs_empty_text")}
              </Typography>
            </div>
          ) : (
            data.map((run) => (
              <div className={classes.openRunRow} key={run.run_id}>
                <div className={classes.openRunIdentity}>
                  <FiberManualRecordIcon className={classes.openRunPulse}/>
                  <div className={classes.openJobCellText}>
                    <Typography variant="subtitle1" component="p" className={classes.jobName}>
                      {(run.job || translate('n8n', 'unknown_label')).toUpperCase()}
                    </Typography>
                    <Typography variant="subtitle2" component="p" className={classes.jobMeta}>
                      Run ID: {run.run_id || '-'}
                    </Typography>
                  </div>
                </div>

                <Typography className={classes.openRunDuration}>
                  {run.start_time
                    ? moment(run.start_time).fromNow()
                    : translate('n8n', 'starting_label')}
                </Typography>

                <span className={classes.openRunStatus}>
                  {translate('n8n', 'running_label')}
                </span>
              </div>
            ))
          )}
        </div>
      )}
    </>
  );
};

export default OpenRuns;